<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>内容安全管理 ><b>铭感词列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
	        <span class="search_span_width">
	            <span class="search_span_width_part1">审核状态：</span>
	  				 <Select v-model="search.status" clearable style="width:260px">
						 <Option value="1" :key="1">待审核</Option>
	  				        <Option value="2" :key="2">审核通过</Option>
	  						<Option value="3" :key="3">审核拒绝</Option>
	  				</Select>
	        </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getSensitiveWordsList()">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="words_list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getSensitiveWordsList"/>
        </Card>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      showmodal:false,
      recordTotal:0,
      search:{
        status:''
      },
      page:1,
      words_list:[],
      words:{
        id:0,
        studio_id: 0,
        studio_name:'',
        status:'',
        content:'',
        scan_words:'',
      },
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center' },
        { title: '直播间ID', key: 'studio_id', align: 'center' },
        { title: '直播间名称', key: 'studio_name', align: 'center' },
        { title: '文本内容', key: 'content', align: 'center' },
        { title: '铭感词内容', key: 'scan_words', align: 'center' },
        { title: '审核状态', key: 'status', align: 'center',
        render: (h, params) => {
              var txt = '';
              if (params.row.status =='2') {
                txt = '审核通过';
              } else if (params.row.status =='3') {
                txt = '审核拒绝';
              } else{
                txt = '待审核';
              }

              return h("div",{},txt);
            }
          },
        { title: '操作', key: 'action', align: 'center',width: 200,
          render: (h, params) => {
            let btns=[]
            if (params.row.status == '1') {
              btns.push(
                  h('Button', {
                    props: { type: 'warning', size: 'small' },
                    style: { marginRight: '5px', marginBottom: '5px'},
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          content: '<p>确定通过吗？</p>',
                          onOk: () => {
                            this.updateStatus(params.row.id, 2);
                          }
                        });
                      }
                    }
                  }, "通过"),
              );
              btns.push(
                  h('Button', {
                    props: { type: 'warning', size: 'small' },
                    style: { marginRight: '5px', marginBottom: '5px'},
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          content: '<p>确定拒绝吗？</p>',
                          onOk: () => {
                            this.updateStatus(params.row.id, 3);
                          }
                        });
                      }
                    }
                  }, "拒绝"),
              );
              return h("div",btns);
            } else if (params.row.status == '3') {
              var txt = '通过';
              var status = 2;
            } else if (params.row.status == '2') {
              var txt = '拒绝';
              var status = 3;
            }

            btns.push(
                h('Button', {
                  props: { type: 'warning', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        content: '<p>确定'+txt+'吗？</p>',
                        onOk: () => {
                          this.updateStatus(params.row.id, status);
                        }
                      });
                    }
                  }
                }, txt),
            );

            return h("div",btns);
          }
        }
      ],
      uploadHeader:{
        "Authorization":localStorage.getItem('token')
      },
    }
  },
  mounted:function(){
    this.getSensitiveWordsList();
  },
  methods:{
    getSensitiveWordsList(page=this.page) {
      this.page = page;
      let p = {'page' : page}
      let params = Object.assign(this.search, p);

      this.http.get('/admin/studio/getSensitiveWordsList',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.words_list = data.data.list;
          this.recordTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    updateStatus(id,status){
      this.http.post('/admin/studio/updateStudioWordStatus',{id:id,status:status}).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.info(data.message);
          this.getSensitiveWordsList(this.page);
          return true;
        }
      });
    },
  }

}
</script>